import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import "chart.js";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import $ from "jquery";
import "popper.js";
window.$ = $;
window.jQuery = $;
import "bootstrap/dist/js/bootstrap.min.js";
import '@fortawesome/fontawesome-free/css/all.min.css';
createApp(App).use(store).use(router).mount('#app')
 if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
     
    
    
    }; 

 
 
 